const MaskDirective = angular.module('MaskDirective', [])
    .directive('pwMask', ['$timeout', maskDirective]);

function maskDirective($timeout) {
    return {
        link: function (scope, elem, attrs) {
            $timeout(function () {

                $(elem).inputmask({
                    mask: attrs.pwMask,
                    autoUnmask: true,
                    showMaskOnHover: false,
                    showMaskOnFocus: false
                });
            });
        }
    };
}


export default MaskDirective;
